import Cookies from "js-cookie";
import Swal from "sweetalert2"; // 加入 SweetAlert2 提示

const Auth = {
  // 解析並取得 JWT Payload
  getPayload() {
    const token = Cookies.get("token"); // 控制：從 Cookie 取得 token
    if (!token) return null;
    const payloadBase64 = token.split(".")[1]; // 控制：取出第二段 Payload
    try {
      // Base64 URL decode
      const payloadJson = decodeURIComponent(
        atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"))
          .split("")
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join("")
      );
      return JSON.parse(payloadJson); // 控制：回傳 Payload 物件
    } catch (e) {
      console.error("JWT Payload 解析失敗：", e);
      return null;
    }
  },

  // 檢查是否已登入
  checkLogin(router) {
    const token = Cookies.get("token");
    if (!token) {
      Swal.fire({
        icon: "warning",
        title: "未登入",
        text: "請重新登入！",
      }).then(() => {
        if (router.currentRoute.path !== "/login") {
          router.push("/login"); // 避免重複導航
        }
      });
      return false;
    }
    console.log("使用者已登入，token:", token);
    return true;
  },

  // 登出功能
  logout(router) {
    Cookies.remove("token");
    Cookies.remove("email");
    Cookies.remove("role");

    Swal.fire({
      icon: "success",
      title: "登出成功！",
      showConfirmButton: false,
      timer: 1200,
    }).then(() => {
      if (router.currentRoute.path !== "/login") {
        router.push("/login"); // 避免重複導航
      }
    });
  },

  // 獲取當前用戶角色
  getRole() {
    const payload = Auth.getPayload(); // 控制：取得解析後的 payload
    if (!payload) return null;
    const roleClaim = payload.role || payload["role"];
    return roleClaim != null ? parseInt(roleClaim, 10) : null;
  },

  

  // 檢查角色是否符合權限
  hasPermission(requiredRole) {
    const currentRole = Auth.getRole();
    return currentRole === requiredRole;
  },

  

  // 根據角色跳轉頁面
  redirectToRolePage(router) {
    const role = Auth.getRole();

    if (role == null) {
      Swal.fire({
        icon: "warning",
        title: "登入失效",
        text: "未找到角色，請重新登入！",
      }).then(() => Auth.logout(router));
      return;
    }

    const roleRoutes = {
      0: "/customer-dashboard",
      1: "/admin",
    };

    const targetPath = roleRoutes[role];
    if (!targetPath) {
      Swal.fire({
        icon: "error",
        title: "角色錯誤",
        text: "未知的角色，請重新登入！",
      }).then(() => this.logout(router));
      return;
    }

    if (router.currentRoute.path !== targetPath) {
      router.push(targetPath);
    }
  },
};

export default Auth;
